export default "__VITE_ASSET__DX3o3QVv__"